import { Component, computed, input, output } from '@angular/core';
import { SelectionFilterWithHeaderComponent } from '@vectronic/ui';
import { FilterItemWithLabel } from '@vectronic/util';

@Component({
  selector: 'table-datatable-filter-single-select',
  templateUrl: './datatable-filter-single-select.component.html',
  imports: [SelectionFilterWithHeaderComponent],
})
export class DatatableFilterSingleSelectComponent {
  title = input.required<string>();
  options = input<any>();
  value = input<any | undefined>();
  expanded = input.required<boolean>();
  valueChange = output<any>();
  toggled = output<void>();

  items = computed((): FilterItemWithLabel<any>[] => {
    const opts = this.options();
    if (Array.isArray(opts)) {
      return opts.map(({ item, label }) => ({ item, label }));
    }
    return [];
  });

  onSelectedItemChange(item: any | undefined) {
    this.valueChange.emit(item);
  }
}
